import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

const VoiceConsentDialog = ({ open, onConsent, onDecline }) => {
  return (
    <Dialog open={open} onClose={onDecline} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <HeadsetMicIcon color="primary" />
        Enable Voice Mode
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" paragraph>
            Voice mode lets you have a spoken conversation with your AI therapist
            in real-time, just like a phone call.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            When voice mode is active:
          </Typography>
          <Box component="ul" sx={{ pl: 2, '& li': { mb: 0.5 } }}>
            <Typography component="li" variant="body2" color="text.secondary">
              Your speech is processed in real-time by Google's AI services
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              Your words are transcribed and saved as part of your conversation record, just like text messages
            </Typography>
            <Typography component="li" variant="body2" color="text.secondary">
              You can switch back to text at any time
            </Typography>
          </Box>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          Your microphone will be used while voice mode is active. You can end the
          voice session at any time.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onDecline} color="inherit">
          Stay with Text
        </Button>
        <Button onClick={onConsent} variant="contained" color="primary" startIcon={<HeadsetMicIcon />}>
          Enable Voice Mode
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoiceConsentDialog;
